import { Application } from '@/types/database.types';

export interface DocumentUploadProps {
  data: Partial<Application>;
  onSave: (data: Partial<Application>) => Promise<void>;
}

export interface OtherDocument {
  name: string;
  url: string;
}

export const MAX_DOCUMENTS_PER_FIELD = 10;
export const MAX_OTHER_DOCUMENTS = 10;

// Document fields constants - now supporting arrays for multiple documents
export const ARRAY_DOCUMENT_FIELDS = [
  'employee_census_file',
  'dependent_census_file',
  'workers_comp_declaration_file',
  'workers_comp_loss_runs_file',
  'health_insurance_renewal_file',
  'sbc_file',
  'tax_exempt_status_file',
  'other_documents'
];

// Keep these exports for backward compatibility
export const STRING_FIELDS: string[] = [];
export const ARRAY_FIELDS = ARRAY_DOCUMENT_FIELDS;
